import { NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-logo',
    standalone: true,
    imports: [NgOptimizedImage],
    template: ` <img ngSrc="favicon.png" alt="Site icon" [width]="width" [height]="height" /> `
})
export class AppLogo {
    @Input() width = 32;
    @Input() height = 32;
}
